// Common APIs
export const COMMON_APIS = {
  GET_COUNTRIES: 'countries',
  GET_STORES: 'stores/all',
};

// Auth APIs
export const AUTH_APIS = {
  LOGIN: 'vendoradmin/login',
  FORGOT_PASSWORD: 'forget-password',
  RESET_PASSWORD: 'reset-password',
  LOGIN_VIA_SWITCH: 'login-via-switch',
};

// User Management APIs
export const DASHBOARD_APIS = {
  GET_DASHBOARD: 'dashboard',
  GET_USER_ORDERS: 'dashboard/user-orders',
};

// User Management APIs
export const USER_APIS = {
  ADD_UPDATE_USER: 'users/add-update',
  GET_USER_DETAIL: `users`,
  GET_ROLE_LIST: 'roles/all',
  GET_STORE_LIST: 'stores/all',
  GET_USER_LIST: 'users',
  DELETE_USER: `users`,
};

// User Role Management APIs
export const USER_ROLE_APIS = {
  GET_ROLE_LIST: 'roles/get-roles',
  ADD_UPDATE_ROLE: 'roles/add-update',
  DELETE_ROLE: `roles`,
  GET_ROLE_DETAIL: `roles`,
  GET_PERMISSIONS: `roles/permissions`,
};

// Device Management APIs
export const DEVICE_APIS = {
  GET_DEVICE_LIST: 'get-devices',
  ADD_DEVICE: 'add-device',
  GET_BUSINESS_LOCATIONS: `get-business-locations'`,
  GET_DEVICE_DETAIL: `device-details`,
  DELETE_DEVICE: `delete-device`,
};

// Coupon Management APIs
export const COUPON_APIS = {
  GET_COUPON_LIST: 'coupons',
  ADD_UPDATE_COUPON: 'coupons/add-update',
  GET_COUPON_DETAIL: `coupons`,
  DELETE_COUPON: `coupons`,
};

// Vendor Profile APIs
export const VENDOR_PROFILE_APIS = {
  GET_PROFILE: 'profile',
  UPDATE_PROFILE: 'profile/update',
  CHANGE_PASSWORD: 'change-password',
};


// Role Permission Groups APIs
const ROLE_PERMISSION_GROUP_BASE = 'permission-groups';
export const ROLE_PERMISSION_GROUP_APIS = {
  GET_ROLE_PERMISSION_GROUP_LIST: `${ROLE_PERMISSION_GROUP_BASE}`,
  ADD_UPDATE_ROLE_PERMISSION_GROUP: `${ROLE_PERMISSION_GROUP_BASE}/add-update`,
  DELETE_ROLE_PERMISSION_GROUP: `${ROLE_PERMISSION_GROUP_BASE}`,
  GET_ROLE_PERMISSION_GROUP_DETAIL: `${ROLE_PERMISSION_GROUP_BASE}`,
  GET_PERMISSIONS: `${ROLE_PERMISSION_GROUP_BASE}/permissions`,
  GET_ALL_ROLE_PERMISSION_GROUPS: `${ROLE_PERMISSION_GROUP_BASE}/all`,
};

// Subscription APIs
const SUBSCRIPTION = 'subscriptions';
export const SUBSCRIPTION_APIS = {
  GET_SUBSCRIPTION_LIST: `${SUBSCRIPTION}`,
  GET_SUBSCIPTION_DETAIL: `${SUBSCRIPTION}/current`,
};

// Customer Insights Report APIs
const CUSTOMER_INSIGHTS = 'customer-insights-report';
export const CUSTOMER_INSIGHTS_REPORT_APIS = {
  GET_PRODUCT_PERFOMANCE: `${CUSTOMER_INSIGHTS}/product-performance`,
  GET_SALES_BY_HOURS: `${CUSTOMER_INSIGHTS}/sales-by-hours`,
  GET_SALES_VS_STORES: `${CUSTOMER_INSIGHTS}/sales-vs-stores`,
  GET_SALES_VS_CATEGORIES: `${CUSTOMER_INSIGHTS}/sales-vs-categories`,
  GET_SALES_VS_GROUPS: `${CUSTOMER_INSIGHTS}/sales-vs-groups`,
  GET_SALES_VS_DAYS: `${CUSTOMER_INSIGHTS}/sales-vs-days`,
};

